export default {
	"ce00e28e28a14624e4d1b3d5da4ba4e4": "確認訂單收銀台-支付方式選擇",
	"5d459c2acec131b937ffa8187dddf1bc": "支付寶訂閲",
	"f4357d2202215acb7588ce97be551c33": "確認訂單收銀台-支付方式",
	"050b13ff8def783c71f936c7ccc00c3f": "支付寶",
	"bb38bad975196de9894fc83ec1653ebc": "微信支付",
	"8155a5bd453551f9108bc90ff99ce8f9": "支付寶掃碼付",
	"aa360aebbaa7766fcf320dd73211797b": "支付寶 | 先學後付",
	"faafa32c8544dee8561a1b905c2558e2": "先學後付",
	"bd29a1532de9b1711fa58ee6f120bcb3": "試學30天，滿意再付款"
}
